module.exports = __webpack_public_path__ + "img/1.6cf87f98.jpg";